export default "__VITE_ASSET__C05L8UEz__"